import { render, staticRenderFns } from "./CampanhaPieChart.vue?vue&type=template&id=0b5f211a&scoped=true&"
import script from "./CampanhaPieChart.vue?vue&type=script&lang=js&"
export * from "./CampanhaPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CampanhaPieChart.vue?vue&type=style&index=0&id=0b5f211a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f211a",
  null
  
)

export default component.exports